import { GALLERY } from "@/constants/site";

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-[#0B3B39]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C5A880]">Gallery</p>
          <h2 className="font-serif-display font-light text-3xl md:text-4xl lg:text-5xl tracking-tight text-[#FDFBF7] mt-4 leading-tight">
            Glimpses of the retreat.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-16">
          {GALLERY.map((g, i) => (
            <div key={i} className="overflow-hidden group" data-testid={`gallery-item-${i}`}>
              <img
                src={g.src}
                alt={g.alt}
                className="w-full h-56 md:h-72 object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
